var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, cloneElement } from "react";
import classNames from "classnames";

export var MenuItem = function (_Component) {
	_inherits(MenuItem, _Component);

	function MenuItem() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, MenuItem);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleMenuEvent = function (e) {
			e.preventDefault();
			_this.props.handleMenuEvent(e, _this.props.item);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(MenuItem, [{
		key: "render",
		value: function render() {
			var item = this.props.item;
			var className = classNames({
				"zebulon-contextmenu-item": true,
				"zebulon-contextmenu-item-separation": item.separation,
				"zebulon-contextmenu-item-disable": item.disable,
				"zebulon-contextmenu-item-selected": item.opened || item.selected,
				"zebulon-contextmenu-item-checked": item.checked,
				"zebulon-contextmenu-sub-menu ": item.type === "sub-menu"
			});
			var check = item.checked ? React.createElement(
				"div",
				{ style: { marginRight: ".3em" } },
				"\u221A"
			) : null;
			var arrow = item.type === "sub-menu" ? React.createElement(
				"div",
				{
					style: {
						marginLeft: ".3em",
						textAlign: "right"
					}
				},
				"\u203A"
			) : null;
			return React.createElement(
				"div",
				{
					className: className,
					onClick: this.handleMenuEvent,
					onMouseOver: this.handleMenuEvent
				},
				React.createElement(
					"div",
					{
						style: {
							textAlign: "left",
							marginRight: ".5em",
							display: "flex"
						}
					},
					check,
					item.caption
				),
				React.createElement(
					"div",
					{ style: { textAlign: "right", display: "flex" } },
					item.accelerator,
					arrow
				)
			);
		}
	}]);

	return MenuItem;
}(Component);
var MENU_EVENT = "MENU_EVENT";
export var ContextualMenu = function (_Component2) {
	_inherits(ContextualMenu, _Component2);

	function ContextualMenu(props) {
		_classCallCheck(this, ContextualMenu);

		var _this2 = _possibleConstructorReturn(this, (ContextualMenu.__proto__ || Object.getPrototypeOf(ContextualMenu)).call(this, props));

		_this2.buildItems = function (items, style, level, handleMenuEvent, keyEvent) {
			return React.createElement(
				"div",
				{
					key: "group-" + level,
					className: "zebulon-contextmenu-group",
					style: style
				},
				items.map(function (item, index) {
					item.level = level;
					if (item.type === "jsx") {
						return cloneElement(item.content, {
							keyEvent: keyEvent,
							ref: function ref(_ref2) {
								return _this2.element = _ref2;
							}
						});
					} else {
						return React.createElement(MenuItem, {
							key: "item-" + item.id,
							item: item,
							handleMenuEvent: handleMenuEvent
						});
					}
				})
			);
		};

		_this2.buildMenu = function (menu, top, left, handleEvent, keyEvent) {
			if (menu && menu.visible) {
				var opened = 0,
				    level = 0,
				    groupTop = 0;
				var item = menu,
				    groups = [];
				var style = {
					position: "absolute",
					top: top,
					left: left,
					display: "flex"
				};
				while (opened >= 0) {
					groupTop += opened * 24;
					var group = _this2.buildItems(item.children, {
						position: "relative",
						top: groupTop // a voir 24 pour prendre en compte le padding 2
					}, level, handleEvent, keyEvent);
					groups.push(group);
					level++;
					opened = item.children.findIndex(function (child) {
						return child.opened;
					});
					if (opened !== -1) {
						item = item.children[opened];
					}
				}
				return React.createElement(
					"div",
					{ id: "contextual-menu", style: style },
					groups
				);
			} else {
				return React.createElement("div", {
					id: "contextual-menu",
					style: { height: 0, width: 0, position: "relative" }
				});
			}
		};

		_this2.close = function () {
			_this2.setState({ menu: null });
		};

		_this2.handleEvent = function (e) {
			var _e$detail = e.detail,
			    position = _e$detail.position,
			    menu = _e$detail.menu,
			    data = _e$detail.data,
			    component = _e$detail.component;

			if (component === _this2.state.component) {
				var rect = _this2.div.getBoundingClientRect();
				position.y -= rect.top;
				position.x -= rect.left;
				var menu_ = _this2.props.getMenu(menu, data);
				if (menu_) {
					menu_.visible = true;
					_this2.setState({ menu: menu_, data: data, position: position });
				}
			}
		};

		_this2.handleMenuEvent = function (e, item, data) {
			if (e.type === "click" && !item.disable) {
				if (item.type === "sub-menu" && item.children && item.children.length) {
					item.opened = !item.opened;
					_this2.navigation = false;
					if (item.opened) {
						if (_this2.openedLevel[item.level] && _this2.openedLevel[item.level].id !== item.id) {
							_this2.openedLevel[item.level].opened = false;
						}
						_this2.openedLevel[item.level] = item;
						if (item.children[0].type === "jsx") {
							_this2.navigation = item.children[0].navigation;
						}
					} else {
						_this2.openedLevel[item.level] = undefined;
					}
					_this2.setState({ menu: _this2.state.menu });
				} else if (item.onClick) {
					var menuItem = item.onClick(_this2.state.data, item);
					if (item.type === "sub-menu" && menuItem && menuItem["$$typeof"].toString() === "Symbol(react.element)") {
						var newItem = {
							type: "jsx",
							level: item.level + 1,
							content: menuItem,
							navigation: true
						};
						item.children.push(newItem);
						_this2.openedLevel[item.level] = newItem;
						item.opened = true;
						_this2.setState({ menu: _this2.state.menu });
					} else {
						_this2.close();
					}
				}

				// console.log("internal menu event", e.target, item);
			} else if (e.type === "mouseover" && _this2.hoveredItem.id !== item.id && !item.disable) {
				_this2.hoveredItem.selected = false;
				_this2.hoveredItem = item;
				item.selected = true;
				_this2.setState({ menu: _this2.state.menu });
			}
		};

		_this2.handleKeyDown = function (e, item) {
			// console.log("keydown menu event", e.key, this.element);
			// if (this.element) {
			// 	console.log("keydown menu event1", e.key, this.element.values);
			// }
			if (_this2.state.menu.visible) {
				// escape
				if (e.which === 27) {
					e.preventDefault();
					_this2.close();
					return true;
				}
				if (_this2.navigation && e.key === "Tab") {
					return true;
				}
				_this2.setState({ keyEvent: e });
			}
		};

		_this2.state = {
			menu: null,
			component: props.component,
			position: { x: 0, y: 0 }
		};
		_this2.openedLevel = {};
		_this2.hoveredItem = {};
		return _this2;
	}

	_createClass(ContextualMenu, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			window.addEventListener("MENU_EVENT", this.handleEvent);
			this.div = document.getElementById(this.state.component);
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			window.removeEventListener("MENU_EVENT", this.handleEvent);
		}
	}, {
		key: "render",
		value: function render() {
			if (this.state.menu) {
				return this.buildMenu(this.state.menu, this.state.position.y, this.state.position.x, this.handleMenuEvent, this.state.keyEvent);
			}
			return null;
		}
	}]);

	return ContextualMenu;
}(Component);

export var ContextualMenuClient = function (_Component3) {
	_inherits(ContextualMenuClient, _Component3);

	function ContextualMenuClient() {
		var _ref3;

		var _temp2, _this3, _ret2;

		_classCallCheck(this, ContextualMenuClient);

		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref3 = ContextualMenuClient.__proto__ || Object.getPrototypeOf(ContextualMenuClient)).call.apply(_ref3, [this].concat(args))), _this3), _this3.onContextMenu = function (e) {
			if (e.button === 2) {
				e.preventDefault();
				e.persist();
				var event = new CustomEvent(MENU_EVENT, {
					detail: {
						component: _this3.props.component,
						ref: _this3.ref,
						position: { x: e.clientX, y: e.clientY },
						menu: _this3.props.menu,
						data: _this3.props.collect ? _this3.props.collect(_this3.props) : _this3.props
					}
				});
				window.dispatchEvent(event);
				return true;
			}
		}, _temp2), _possibleConstructorReturn(_this3, _ret2);
	}

	_createClass(ContextualMenuClient, [{
		key: "render",
		value: function render() {
			var _this4 = this;

			var props = Object.assign({}, this.props);
			var children = props.children;
			delete props.children;
			delete props.collect;

			return cloneElement(React.createElement(
				"div",
				{
					onContextMenu: this.props.menu ? this.onContextMenu : undefined,
					ref: function ref(_ref4) {
						return _this4.ref = _ref4;
					}
				},
				children
			), props);
		}
	}]);

	return ContextualMenuClient;
}(Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-controls/lib/ContextualMenu.js
// module id = 54
// module chunks = 0